import { Subject } from 'rxjs';

import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { SnCamera, SnLiveVideoUrls } from '@lib/api/entities';
import { SnMapViewsService } from '@lib/api/services';
import { SnCad } from '@lib/cad';
import {
  snSlideInDown,
  snSlideInRight,
  snSlideInUp,
  snSlideOutDown,
  snSlideOutRight,
  snSlideOutUp,
} from '@lib/common/animations';
import { SnLayoutService } from '@lib/ui/layout';

@Component({
  selector: 'sn-cam-feed',
  templateUrl: './cam-feed.component.html',
  styleUrls: ['./cam-feed.component.scss'],
  animations: [
    snSlideInUp,
    snSlideOutUp,
    snSlideOutRight,
    snSlideInRight,
    snSlideInDown,
    snSlideOutDown,
  ],
})
export class CamFeedComponent implements OnInit, OnDestroy {
  get selectedId(): any {
    return this.cadSelected ? this.cadSelected.id : 'main';
  }

  @Input()
  public isTelestrating: boolean = false;

  @Input() public cadCamList: any[] = [];
  @Input() public unlockedCamList = [];
  @Input() public dockedCams = [];
  @Input() public dockedDrones = [];
  @Input() public playbackCams = [];
  @Input() public hoveredCameraId;
  @Input() public actions;
  @Input() public dragControls;
  @Input() public allowPlayback;
  @Input() public canUnlock: boolean = true;
  @Input() public singleRow: boolean = false;
  @Input() public alwaysOn: boolean = true;
  @Output() public readonly undockCamera = new EventEmitter<SnCamera>();
  @Output() public readonly drawPolyline = new EventEmitter<{
    camera: SnCamera;
    element: Element;
  }>();
  @Output()
  public readonly removePolyline = new EventEmitter<{ camera: SnCamera; element: Element }>();
  @Output()
  public readonly removePlayback = new EventEmitter<SnCamera>();
  @Output()
  public readonly viewPlayback = new EventEmitter<SnCamera>();

  public cadSelected: SnCad;
  public shakyCamera: string;
  public src: SnLiveVideoUrls;
  public hoveredPlaybackId: string;

  public barCollapse = false;

  private _destroy$ = new Subject();

  constructor(
    private readonly _mapViewsService: SnMapViewsService,
    public layout: SnLayoutService,
  ) {}

  public ngOnInit(): void {}

  public removeCamera(camera: SnCamera): void {
    this.undockCamera.next(camera);
  }

  public checkViewer(): boolean {
    return this._mapViewsService.tabPermissions.includes('viewer');
  }

  public checkEditor(): boolean {
    return this._mapViewsService.tabPermissions.includes('editor');
  }

  public checkAdmin(): boolean {
    return this._mapViewsService.tabPermissions.includes('admin');
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public trackCam(index: Number, item: SnCamera): string {
    return item.id;
  }

  public unlockCam(cam: any): void {
    this.unlockedCamList.push(cam);
    this.dockedCams.findIndex((camera) => {
      if (this.unlockedCamList.includes(camera)) {
        this.dockedCams.splice(camera, 1);
      }
    });
  }

  public lockCam(cam: any): void {
    this.unlockedCamList.splice(this.unlockedCamList.indexOf(cam), 1);
    this.dockedCams.push(cam);
  }

  public onPlaybackHover(camera: SnCamera, event: string): void {
    this.hoveredPlaybackId = event === 'enter' ? camera.id : null;
  }

  public onRowScroll(event: WheelEvent): void {
    const row = document.querySelector('.cam-feed__single-row');
    if (row) {
      event.preventDefault();
      row.scrollBy({
        left: event.deltaY < 0 ? -30 : 30,
      });
    }
  }
}
